/** Identifies the hero in the px_captcha_* analytics; both hero requests report under it. */
export const PERIMETERX_FORM = 'homepage_social_post';
